import { usePathname } from '../../../../i18n/i18n-navigation';
import { ERROR_PATH, NOT_AUTHORIZED_PATH } from '../../../../utils/constants/local-paths';
import { type LocalPaths } from '../../../../utils/data/get-local-paths';

type UseIsHeaderSecondaryThemeProps = {
  paths: LocalPaths;
};

export const useIsHeaderSecondaryTheme = ({ paths }: UseIsHeaderSecondaryThemeProps) => {
  const pathname = usePathname();

  const primaryHeaderThemePaths = [
    paths.learnPagePath,
    paths.accountSettingsPagePath,
    paths.searchPagePath,
    paths.adminDashboardPagePath,
    paths.quizPagePath,
    paths.memberDirectoryPath,
    ERROR_PATH,
    NOT_AUTHORIZED_PATH,
  ];

  // this is needed for nested paths for example /member-directory & /member-directory/profile
  const secondaryHeaderThemePaths = [paths.memberDirectoryProfilePath];

  const isSecondaryTheme =
    secondaryHeaderThemePaths.some((path) => pathname.startsWith(path)) ||
    !primaryHeaderThemePaths.some((path) => pathname.startsWith(path));

  return isSecondaryTheme;
};
